import subscription_set from "../datafiles/subscription_set.json";
import service_set from "../datafiles/service_set.json";
import reward_set from "../datafiles/reward_set.json";
import guarantee_set from "../datafiles/guarantee_set.json";

import shareinformation_set from "../datafiles/shareinformation_set.json";
import agreement_set from "../datafiles/agreement_set.json";
import sunriseagreement_set from "../datafiles/sunriseagreement_set.json";

import { PayHelper, getThisSubsIsActive } from "../scCommon/scCommonFunc";
import { GetMoneyValue, GetRewCalcValue } from "../Api/ApiCommon";
import userreport_set from "../datafiles/userreport_set.json";
import userguide_set from "../datafiles/userguide_set.json";
import moment from "moment";


//서비스 데이터
export const GetServiceSetData = (servID) => {
  const ServData = service_set.filter((data) => data.SVC_ID === servID);
  return ServData;
};

// 구독 데이터
export const GetSubscriptionSetData = (subsID) => {
  const SubsData = subscription_set.filter((data) => data.SUBS_ID === subsID);
  return SubsData;
};

// 게런티 데이터
export const GetGuaranteeSetData = (guarID) => {
  const GuarData = guarantee_set.filter((data) => data.GUAR_ID === guarID);
  return GuarData;
};

// 리워드 데이터
export const GetRewardSetData = (rewID) => {
  const RewData = reward_set.filter((data) => data.REW_ID === rewID);
  return RewData;
};

// 동의 데이터
export const GetAgreeSetData = (agreeID, isHost, isSunrise) => {
  const dataSet = isSunrise ? sunriseagreement_set : agreement_set;
  const type = isHost ? "ldr" : "mbr";

  let datas = dataSet.filter((data) =>
    isSunrise
      ? data.SRARGMT_ID === agreeID &&
      data.SRARGMT_TYP === type &&
      data.SRARGMT_USE === 1
      : data.ARGMT_ID === agreeID &&
      data.ARGMT_TYP === type &&
      data.ARGMT_USE === 1
  );

  if (datas.length > 0) {
    datas.sort(function (a, b) {
      if (isSunrise) {
        return a["SRARGMT_ODR"] - b["SRARGMT_ODR"];
      } else {
        return a["ARGMT_ODR"] - b["ARGMT_ODR"];
      }
    });
  }

  return datas;
};

// 동의 데이터 INDEX 리스트
export const GetAgIndexList = (agreeID, isHost, isSunrise) => {
  let agList = [];
  const dataSet = isSunrise ? sunriseagreement_set : agreement_set;
  const type = isHost ? "ldr" : "mbr";

  let datas = dataSet.filter((data) =>
    isSunrise
      ? data.SRARGMT_ID === agreeID &&
      data.SRARGMT_TYP === type &&
      data.SRARGMT_USE === 1
      : data.ARGMT_ID === agreeID &&
      data.ARGMT_TYP === type &&
      data.ARGMT_USE === 1
  );

  if (datas.length > 0) {
    for (let i = 0; i < datas.length; i++) {
      agList.push(datas[i].INDEX);
    }
  }

  return agList;
};

// 동의 데이터 - INDEX로 찾기
export const GetAgreeSetDataByIndex = (agreeIndex, isHost, isSunrise) => {
  const dataSet = isSunrise ? sunriseagreement_set : agreement_set;
  const type = isHost ? "ldr" : "mbr";

  let datas = dataSet.filter((data) =>
    isSunrise
      ? data.INDEX === agreeIndex &&
      data.SRARGMT_TYP === type &&
      data.SRARGMT_USE === 1
      : data.INDEX === agreeIndex &&
      data.ARGMT_TYP === type &&
      data.ARGMT_USE === 1
  );

  if (datas.length > 0) {
    datas.sort(function (a, b) {
      if (isSunrise) {
        return a["SRARGMT_ODR"] - b["SRARGMT_ODR"];
      } else {
        return a["ARGMT_ODR"] - b["ARGMT_ODR"];
      }
    });
  }

  return datas;
};

//카테고리별 서비스 데이터
export const GetServiceSetDataByCategory = (category) => {
  const ServData = service_set.filter((data) => data.SVC_CAT === category);
  return ServData;
};

//카테고리별 서비스 데이터 (숨김 제외)
export const GetServiceSetDataByCategoryNoHide = (category) => {
  const ServData = service_set.filter(
    (data) => data.SVC_CAT === category && data.SVC_ACT !== "hide"
  );
  return ServData;
};

// 전체 서비스 데이터 (숨김 제외)
export const GetServiceSetDataNoHide = () => {
  const ServData = service_set.filter((data) => data.SVC_ACT !== "hide");
  return ServData;
};

// 구독 데이터 가져오기-서비스아이디를 기준으로
export const GetAllSubscriptionSetDataByServID = (servID) => {
  const SubsData = subscription_set.filter((data) => data.SVC_ID === servID);
  return SubsData;
};

// 구독 데이터 가져오기-서비스아이디를 기준으로
export const GetAllNoHideSubscriptionSetDataByServID = (servID) => {
  const today = moment();
  const SubsData = subscription_set.filter(
    (data) =>
      data.SVC_ID === servID &&
      // getThisSubsIsActive(data)
      data.SUBS_ACT !== "hide" &&
      moment().isBetween(
        moment(data.SUBS_ADATE).format("YYYY-MM-DD HH:mm"),
        moment(data.SUBS_EDATE).format("YYYY-MM-DD HH:mm")
      )

    // data.SUBS_ACT !== "hide" &&
    // today.diff(moment(data.SUBS_ADATE)) > 0
  );
  return SubsData;
};

// hide가 아닌 구독 데이터 개수 가져오기-서비스아이디를 기준으로
export const GetAllNoHideSubscriptionCount = (servID) => {
  const SubsData = subscription_set.filter((data) => data.SVC_ID === servID);
  let activeCnt = 0;
  for (var i = 0; i < SubsData.length; i++) {
    if (SubsData[i].SUBS_ACT !== "hide") {
      // if(SubsData[i].SUBS_ACT != "hide"){
      activeCnt = activeCnt + 1;
    }
  }

  return activeCnt;
};

// Activate 구독 데이터 개수 가져오기-서비스아이디를 기준으로
export const GetAllActiveSubscriptionCount = (servID) => {
  const today = moment();
  const SubsData = subscription_set.filter((data) => data.SVC_ID === servID);
  let activeCnt = 0;
  for (var i = 0; i < SubsData.length; i++) {
    if (getThisSubsIsActive(SubsData[i])) {
      activeCnt = activeCnt + 1;
    }
  }

  return activeCnt;
};

//계정 정보 쉐어 셋 인포
export const GetShareInfoSetByShareInfoID = (shareInfoID) => {
  const ShareSetData = shareinformation_set.filter(
    (data) => data.SHARINFO_ID === shareInfoID
  );
  return ShareSetData;
};


// 구독별 월 최대 세이브 머니 계산.
export const getMaxSavedMonthlyMoneyBySubs = (subsID, isHost) => {
  const SubsData = GetSubscriptionSetData(subsID)[0];
  let value = 0;
  if (SubsData !== undefined) {
    let Comm = isHost
      ? SubsData.COMM_LDRRT / 10000
      : SubsData.COMM_MBRRT / 10000;
    Comm = isHost
      ? Comm * SubsData.SUBS_FEE * (SubsData.POL_SHARMX - 1)
      : Comm * SubsData.SUBS_FEE;

    value =
      Math.round(((SubsData.POL_SHARMX - 1) * SubsData.SUBS_FEE - Comm) / 5) *
      5;
    // value = parseInt((SubsData.POL_SHARMX - 1) * SubsData.SUBS_FEE - Comm);
  }
  return value;
};

//구독별 1년 최대 리워드 계산.
export const getMaxRewYearlyBySubs = (subsID) => {
  const SubsData = GetSubscriptionSetData(subsID)[0];
  const RewData = GetRewardSetData(SubsData.REW_ID)[0];

  const maxStep = PayHelper.get_maxrewardstep(RewData, 12);

  return GetRewCalcValue(true, SubsData.POL_SHARMX - 1, subsID, maxStep);
};

export const getUserReportData = (id) => {
  const ReportData = userreport_set.find((data) => data.RPT_ID === id);
  return ReportData;
};

export const getSubsGuideList = (gID, isHost) => {
  const guideType = isHost ? "ldr" : "mbr";
  const GuideData = userguide_set.filter(
    (data) => data.GUID_ID === gID && data.GUID_TYP === guideType
  );
  return GuideData;
};

export const GetSubsDataOnlyActivateByServiceId = (svcID) => {
  const SubsData = subscription_set.filter(
    (data) => data.SVC_ID === svcID && getThisSubsIsActive(data)
  );
  return SubsData;
};

// 매달 세이브 할 수 있는 값
export const getMaxSaveMoneyValueOnSubsLists = (scvId) => {
  const SubsList = GetAllNoHideSubscriptionSetDataByServID(scvId);

  let value = 0;
  for (let i = 0; i < SubsList.length; i++) {
    if (getMaxSavedMonthlyMoneyBySubs(SubsList[i].SUBS_ID, true) > value) {
      value = getMaxSavedMonthlyMoneyBySubs(SubsList[i].SUBS_ID, true);
    }
  }
  return GetMoneyValue(value);
};

// 월 정기요금이 가장 적은 구독권의 값을 계산.
export const getMinPerMonthFeeValueOnSubsLists = (scvId) => {
  const SubsList = GetAllNoHideSubscriptionSetDataByServID(scvId);

  let value = 999999;
  for (let i = 0; i < SubsList.length; i++) {
    if (SubsList[i].SUBS_FEE * SubsList[i].POL_SHARMX < value) {
      value = SubsList[i].SUBS_FEE * SubsList[i].POL_SHARMX;
    }
  }
  value = GetMoneyValue(value);
  if (SubsList.length > 1) {
    value = value + "~";
  }
  return value;
};

// 월 내가 내야하는 요금이 가장 적은 구독권의 값을 계산(subsfee + comm)
export const getMinPerMonthFeeJustMeWithCommValueOnSubsLists = (scvId) => {
  // const SubsList = GetSubsDataOnlyActivateByServiceId(scvId);
  const SubsList = GetAllNoHideSubscriptionSetDataByServID(scvId);

  let value = 999999;
  for (let i = 0; i < SubsList.length; i++) {
    const comm = PayHelper.calc_commission(SubsList[i], SubsList[i].SUBS_FEE);
    if (SubsList[i].SUBS_FEE + comm < value) {
      value = SubsList[i].SUBS_FEE + comm;
    }
  }
  value = GetMoneyValue(value);
  if (SubsList.length > 1) {
    value = value + "~";
  }
  return value;
};

// hide 상태 아닌 subsname 가져오기
export const GetAllNoHideSubsnameList = () => {
  const SubsData = subscription_set.filter((data) => data.SUBS_ACT !== "hide");

  return SubsData?.map((s) => s?.SUBS_ID + "_" + s?.SUBS_NM_TEMP);
};

// 모든 subsname 가져오기
export const GetAllSubsnameList = () => {
  const SubsData = subscription_set;

  return SubsData?.map((s) => s?.SUBS_ID + "_" + s?.SUBS_NM_TEMP);
};

// SUBS_ADATE 가 오늘 이전인 subscription 가져오기
export const getActiveSubscription = () => {
  const today = moment();
  const SubsData = subscription_set.filter((data) => getThisSubsIsActive(data));
  return SubsData;
};

// 서비스 별 이용 가이드
export const serviceGuide = (svcId) => {
  switch (svcId) {
    case 100: // 넷플릭스
      return "https://peachgrove.notion.site/6e90b470718f4d3c90e3bd8986bdb0f7";

    case 200: // 왓챠
      return "https://peachgrove.notion.site/371aa81d86034575b9878d26dc589159";

    case 300: // 웨이브
      return "https://peachgrove.notion.site/55a0dae63b9040d3a09ee966c7abb92a";

    case 400: // 티빙
      return "https://peachgrove.notion.site/bf337400cc9c4113ad523e75b701b5b3";

    case 500: // 디즈니 플러스
      return "https://peachgrove.notion.site/9bf7e6a9b63f46dda3a18d3afa3e8ac3";

    case 700: // 프라임 비디오
      return "https://peachgrove.notion.site/209bd0cec28d43ca847967259937f5cc";

    case 1100: // 오피스 365
      return "https://peachgrove.notion.site/365-62fa3906f79749bf87375523cd86730e";

    case 1200: // 닌텐도
      return "https://peachgrove.notion.site/70f9d0c012a844898ac4d81cdc475ce0";

    case 1300: // 윌라
      return "https://peachgrove.notion.site/1ce2bf9b8e8e42c4bc383a516c8d1048";

    case 1400: // 네이버
      return "https://peachgrove.notion.site/f1dd194cee704f6abca6d5cde9b14afc";

    case 1500: // 애플
      return "https://peachgrove.notion.site/f524fc6db24345708416963a46203784";

    case 1600: // 라프텔
      return "https://peachgrove.notion.site/83b1c3685bba4f4cb3a7d74edd16b8aa";

    case 1700: // 테니스 tv
      return "https://peachgrove.notion.site/TV-5b45c82b915d4443ac6da1105aa9549f";

    case 1800: // 케이크
      return "https://peachgrove.notion.site/cb181c947a8d451eaad4f5ee4fb84c22";

    case 1900: // 해피독
      return "https://peachgrove.notion.site/TV-6563a5c3385e4c3fabc6c6062ee049ad";

    case 2000: // 리그패스
      return "https://peachgrove.notion.site/NBA-b7a15269212a47dc91a44f0cb00bd2a1";

    case 2100: // 듀오링고
      return "https://peachgrove.notion.site/014a156f6a5b471bb5423b0e556942df";

    default:
      break;
  }
};

// 연장될 파티의 subsId 구하기
export const getExtendSubsId = (grpId) => {
  const activateSubsData = subscription_set.filter(
    (data) => data.JGRP_ID === grpId && data.SUBS_ACT === "activate"
  );

  const descSubsData = activateSubsData?.sort((a, b) => b.SUBS_ID - a.SUBS_ID);

  return descSubsData[0]?.SUBS_ID ?? 0;
};

// service_set의 SVC_ACT가 activate인 subscription_set
export const GetActiveSubsnameList = () => {
  const subsData = subscription_set?.filter((subData) =>
    service_set?.some(
      (servData) =>
        servData.SVC_ACT === "activate" && servData?.SVC_ID === subData?.SVC_ID
    )
  );

  return subsData?.map((s) => s?.SUBS_ID + "_" + s?.SUBS_NM_TEMP);
};

// 해당 subsId이 activate 인지 아닌지
export const GetIsActivatedSubsId = (subsId) => {
  let isActivate = false;

  const SubsData = subscription_set.filter(
    (data) => data.SUBS_ID === subsId && data.SUBS_ACT === "activate"
  );

  if (SubsData[0]) {
    isActivate = true;
  } else {
    isActivate = false;
  }

  return isActivate;
};
